export default __webpack_public_path__ + "static/media/no-af.4bb04737.svg";